// This file exports the current device's Device Pixel Ratio (or DPR).
// It is mainly used to tell image hosting providers how big of images to draw.

let dpr

window.matchMedia || (window.matchMedia = () => ({ matches: false }))

if (window.devicePixelRatio) {
  dpr = Math.round(window.devicePixelRatio) || 1 // Default to 1 for odd rounding
} else if (
  window.matchMedia(
    '(-webkit-min-device-pixel-ratio: 1.5),(min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)',
  ).matches
) {
  dpr = 1.5
} else if (
  window.matchMedia(
    '(-webkit-min-device-pixel-ratio: 2),(min--moz-device-pixel-ratio: 2),(-o-min-device-pixel-ratio: 2/1),(min-resolution: 2dppx)',
  ).matches
) {
  dpr = 2
} else {
  dpr = 1
}

export default dpr
